import { LOGIN_ATTEMPT, LOGIN_RESULT, UNAUTHORIZED_CASE, STUDENT_ACCESS_RESULT } from "../Actions/AuthorizationActions"

//Constants
export const LOGIN_STATUS_CHECK = +1
export const LOGIN_STATUS_VALID = +2
export const LOGIN_STATUS_REQUIRED = +3

const InitialState = {
    IsLogging: false,
    LoggingError: '',
    username:'',
    name:'',
    roles:[],
    LoginStatus: LOGIN_STATUS_CHECK,
    student:false,
    student_key:''
}

export default function QueryReducer(state = InitialState, action){
    switch(action.type){

        case STUDENT_ACCESS_RESULT: {
            return{
                ...state,
                IsLogging: false,
                LoggingError:'',
                student:action.student,
                LoginStatus:action.LoginStatus,
                roles: action.roles,
                username:'Student',
                name:'Student',
                student_key:action.student_key
            }
        }

        case LOGIN_ATTEMPT: {
            return{
                ...state,
                IsLogging: true,
                LoggingError:'',
                student:false
            }
        }

        case LOGIN_RESULT:{
            return{
                ...state,
                IsLogging:false,
                LoggingError:action.LoggingError,
                token: action.token,
                username: action.username,
                name:action.name,
                roles: action.roles,
                student: action.student ? action.student : false,
                LoginStatus: action.token ? LOGIN_STATUS_VALID : LOGIN_STATUS_REQUIRED,
                student_key:action.student_key,
                student_key:action.student_key,
                data_pool_name:action.data_pool_name,
                data_pool_id:action.data_pool_id

            }
        }

        case UNAUTHORIZED_CASE:{
            return{
                ...state,
                IsLogging:false,
                LoggingError:'',
                token: '',
                LoginStatus:LOGIN_STATUS_REQUIRED
            }
        }

        default:
            {
                return {
                    ...state
                }
            }
        
    }


}